import { useEffect, useMemo, useState } from "react";
import {
  MONITORING_PERIODS,
  RANGE_STEP_MS,
  resolveMonitoringRange,
  type BroadcastWindow,
  type MonitoringPeriod,
} from "./period";

// Шаг тика равен шагу округления `to` в resolveMonitoringRange: так каждый
// тик даёт новые переменные запроса.
const LIVE_REFRESH_MS = RANGE_STEP_MS;

// Пока вход подключён, `now` тикает раз в 30 с: границы периода сдвигаются,
// Apollo перезапрашивает по новым переменным, отдельный pollInterval не нужен.
export function useMonitoringPeriod(options: {
  live: boolean;
  broadcast?: BroadcastWindow | null;
}): {
  period: MonitoringPeriod;
  setPeriod: (period: MonitoringPeriod) => void;
  range: { from: string; to: string };
  periods: MonitoringPeriod[];
} {
  const { live, broadcast } = options;
  const [period, setPeriod] = useState<MonitoringPeriod>(
    broadcast ? "broadcast" : "1h"
  );
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    if (!live) return undefined;
    const timer = window.setInterval(() => setNow(new Date()), LIVE_REFRESH_MS);
    return () => window.clearInterval(timer);
  }, [live]);

  const periods = useMemo(
    () =>
      MONITORING_PERIODS.filter(
        (item) => item !== "broadcast" || Boolean(broadcast)
      ),
    [broadcast]
  );
  const range = useMemo(
    () => resolveMonitoringRange(period, now, broadcast),
    [period, now, broadcast]
  );

  return { period, setPeriod, range, periods };
}
